/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Meeting_Type_LabelInputs */



/**
* | output |
* | --- |
* | "Conversation type" |
*
* @param {Manual_Meeting_Type_LabelInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const manual_meeting_type_label = /** @type {((inputs?: Manual_Meeting_Type_LabelInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Meeting_Type_LabelInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Gesprekstype")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Type d'entretien")
	return /** @type {LocalizedString} */ ("Conversation type")
});